"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readPageUpgradeEntry = readPageUpgradeEntry;
const page_document_maps_1 = require("./page-document-maps");
const page_format_chain_1 = require("./page-format-chain");
const page_structure_entry_1 = require("./page-structure-entry");
/** Formats 2/3 may name their head explicitly; all other stored fields use the entry decoder. */
function readPageUpgradeEntry(id, value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        throw new page_format_chain_1.PageFormatChainError('Invalid page structure entry: ' + id);
    const { s, ...fields } = value;
    if (s !== undefined && s !== page_document_maps_1.PAGE_DOCUMENT_PART_ID)
        throw new page_format_chain_1.PageFormatChainError('Page format 3 with parts needs its parts to upgrade');
    const entry = (0, page_structure_entry_1.normalizePageStructureEntry)(fields, page_document_maps_1.PAGE_DOCUMENT_PART_ID);
    if (!entry)
        throw new page_format_chain_1.PageFormatChainError('Invalid page structure entry: ' + id);
    return entry;
}
